class Recruitment {
    constructor(data = {}) {
      this.id = data.id || data._id || null;
      this._id = data._id || data.id || null;
      this.jobTitle = data.jobTitle || '';
      this.department = data.department || '';
      this.positions = data.positions || 1;
      this.jobDescription = data.jobDescription || '';
      this.requirements = data.requirements || '';
      this.experienceRequired = data.experienceRequired || '';
      this.salaryRange = data.salaryRange || '';
      this.location = data.location || '';
      this.jobType = data.jobType || 'Full-time';
      this.status = data.status || 'Open';
      this.postedDate = data.postedDate || new Date().toISOString().split('T')[0];
      this.closingDate = data.closingDate || '';
      this.applicants = data.applicants || 0;
      this.shortlisted = data.shortlisted || 0;
      this.hired = data.hired || 0;
      this.createdAt = data.createdAt || new Date().toISOString();
    }
  
    getStatusColor() {
      const colors = { 'Open': '#10b981', 'Closed': '#ef4444', 'On Hold': '#f59e0b', 'Filled': '#3b82f6' };
      return colors[this.status] || '#6b7280';
    }
  
    validate() {
      const errors = [];
      if (!this.jobTitle?.trim()) errors.push('Job title is required');
      if (!this.department) errors.push('Department is required');
      if (this.positions <= 0) errors.push('Positions must be greater than 0');
      if (!this.jobDescription?.trim()) errors.push('Job description is required');
      return { isValid: errors.length === 0, errors };
    }
  
    toJSON() { return { ...this }; }
    static fromJSON(json) { return new Recruitment(json); }
  }
  export default Recruitment;